import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigService {

  constructor(
    public router : Router
  ) { }
  nav(direction: string){
    this.router.navigate([`/${direction}`]);
  }
}

